import {
  Recomendation,
  RecomendationData,
} from '@/domain/entities/Recommendation'
import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './Base'

export class RecomendationDataMapper extends BaseResponseMapper {
  public convertRecomendationFromApi(
    result: AxiosResponse<any>
  ): Recomendation {
    const { data } = result
    return new Recomendation(
      data.success,
      data.message,
      data.data.map((val) => new RecomendationData(val.id, val.title, val.type))
    )
  }
}
